import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import HealerSection from './components/HealerSection';
import CTASection from './components/CTASection';
import BookingSection from './components/BookingSection';
import SEOJsonLd from '../../components/base/SEOJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://thesunshinehealing.com';

const studioImage = 'https://static.readdy.ai/image/705f25322c737a89d377410a2840897b/4f8a5efd8fae0153510f9a508669b84c.png';
const ogImage = 'https://public.readdy.ai/ai/img_res/72aba1d57c1568af1ea54e71731b3d0f.jpg';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${siteUrl}/#business`,
    name: '阳光灵性疗愈工作室 / Sunshine Healing Studio',
    url: siteUrl,
    image: ogImage,
    logo: studioImage,
    description:
      'Singapore professional spiritual healing studio offering PELLOWAH energy healing, UMANA chakra 8–12 activation, Quantum Hypnosis QHHT, Bach Flower Remedies, Oracle Card Reading and Chakra Assessment. Bilingual Chinese & English.',
    telephone: '+6593651286',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Singapore',
      addressCountry: 'SG',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 1.3521,
      longitude: 103.8198,
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '10:00',
      closes: '20:00',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Spiritual Healing Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'PELLOWAH Energy Healing', url: `${siteUrl}/services/pellowah` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'UMANA Energy Healing', url: `${siteUrl}/services/umana` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Bach Flower Remedies', url: `${siteUrl}/services/bach` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Quantum Hypnosis QHHT', url: `${siteUrl}/services/quantum` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Oracle Card Reading', url: `${siteUrl}/services/oracle` } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Chakra Assessment', url: `${siteUrl}/services/chakra` } },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Sunshine Healing Studio',
    url: siteUrl,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页 Home', item: `${siteUrl}/` },
    ],
  },
];

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <title>阳光灵性疗愈工作室 新加坡 | Sunshine Healing Studio Singapore</title>
      <meta name="description" content="新加坡专业灵性疗愈工作室，提供PELLOWAH能量疗愈、UMANA脉轮激活、量子催眠QHHT、巴赫花精、神谕卡解读及脉轮测试。双语中英服务。Singapore spiritual healing studio: PELLOWAH, UMANA chakra activation, Quantum Hypnosis QHHT, Bach Flower Remedies, Oracle Cards. WhatsApp: +65 9365 1286" />
      <meta name="keywords" content="新加坡灵性疗愈, 新加坡pellowah, 新加坡umana, 新加坡巴赫花精疗愈, 新加坡量子催眠, 新加坡神谕卡, 新加坡脉轮测试, 灵气疗愈, 新加坡灵气疗愈, 新加坡占卜, 神谕卡解读, 脉轮疗愈新加坡, 脉轮测试新加坡, 新加坡催眠, pellowah singapore, umana singapore, bach flower singapore, QHHT singapore, Quantum Hypnosis singapore, chakra assessment singapore, chakra healing singapore, reiki singapore, reiki healing singapore, PELLOWAH, UMANA" />
      <link rel="canonical" href={`${siteUrl}/`} />
      <meta property="og:title" content="阳光灵性疗愈工作室 新加坡 | Sunshine Healing Studio Singapore" />
      <meta property="og:description" content="新加坡专业灵性疗愈：PELLOWAH能量疗愈、UMANA脉轮激活、量子催眠QHHT、巴赫花精、神谕卡、脉轮测试。双语服务。" />
      <meta property="og:url" content={`${siteUrl}/`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <SEOJsonLd id="home-jsonld" data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <HealerSection />
        <CTASection />
        <BookingSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
